import styled from 'styled-components';
import { Box } from '../../../../layout/Box';

export const IconWrapper = styled(Box).withConfig({ displayName: 'IconWrapper' }).attrs({
    position: 'absolute',
    p: 0.25,
    borderRadius: 1,
    background: 'var(--control-secondary-background)',
    backdropFilter: 'blur(20px)',
})``;
